import { cn } from '@/lib/utils'

export interface CandidateStatBarProps {
  label: string
  value: number // 0-100
  /** Color mode: 'positive' = higher is green, 'negative' = lower is green, 'neutral' = always blue */
  colorMode?: 'positive' | 'negative' | 'neutral'
  className?: string
}

function getColorClass(value: number, colorMode: 'positive' | 'negative' | 'neutral'): string {
  if (colorMode === 'neutral') {
    return 'bg-blue-500'
  }

  // For positive mode: high = green, low = red
  // For negative mode: low = green, high = red
  const effectiveValue = colorMode === 'negative' ? 100 - value : value

  if (effectiveValue >= 70) {
    return 'bg-green-500'
  } else if (effectiveValue >= 40) {
    return 'bg-yellow-500'
  } else {
    return 'bg-red-500'
  }
}

export function CandidateStatBar({
  label,
  value,
  colorMode = 'positive',
  className,
}: CandidateStatBarProps) {
  const clampedValue = Math.max(0, Math.min(100, value))
  const colorClass = getColorClass(clampedValue, colorMode)

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="text-muted-foreground w-20 shrink-0 text-xs">{label}</span>
      <div className="bg-muted relative h-2 flex-1 overflow-hidden rounded-full">
        <div
          className={cn('h-full transition-all', colorClass)}
          style={{ width: `${clampedValue}%` }}
        />
      </div>
      <span className="w-7 shrink-0 text-right text-xs font-medium">{clampedValue}</span>
    </div>
  )
}
